import { Input } from "@material-tailwind/react"
import React from "react"
import { WBLabel } from "./WBLabel"

function WBInput ({
    label,
    disabled = false,
    className,
    value,
    onChange = () => {},
    placeholder,
    shadowInput = false,
    icon,
    onEnterClick = () => {}
}) {

    const shadow = shadowInput ? 'shadow-lg shadow-gray-900/5' : ''
    
    return (
        <>
            {label &&
                <WBLabel text={label}/>
            }
            <Input 
                disabled={disabled}
                placeholder={placeholder}
                className={`${className} !border !border-gray-300 bg-white text-gray-900 ${shadow} ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100 focus:!border-gray-900 focus:!border-t-gray-900`}
                labelProps={{className: "hidden"}}
                containerProps={{className: "min-w-0"}}
                value={value}
                onChange={onChange}
                icon={icon ? icon : ''}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') { 
                        if (onEnterClick) { onEnterClick() }
                    }
                }}
            />
        </>
    )
}

export { WBInput }